import { PetParent, PetParentAnimal } from '../../../types/PetParent';

/**
 * The animal driving the pre-surrender Hub experience, or null when the parent
 * isn't eligible. Eligible = an animal in Pre-Surrender care at a Plus
 * ("Enterprise Plus") AWO. When several animals are pre-surrender, the most
 * recent (highest id) wins — deliberately NOT primaryAnimalId, which may point
 * at a previously adopted pet.
 */
export default function getPreSurrenderAnimal(
  petParent: PetParent | null | undefined,
): PetParentAnimal | null {
  if (petParent?.awo?.membershipType !== 'Plus') return null;
  const candidates = (petParent.animals || []).filter((a) => a.careType === 'Pre-Surrender');
  if (candidates.length === 0) return null;
  return candidates.reduce((latest, a) => (Number(a.id) > Number(latest.id) ? a : latest));
}
